// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleTwoToneSvg from "@fishx/icons-svg/es/asn/CopyrightCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var CopyrightCircleTwoTone = function CopyrightCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleTwoToneSvg
  }));
};

CopyrightCircleTwoTone.displayName = 'CopyrightCircleTwoTone';
export default React.forwardRef(CopyrightCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyrightCircleTwoTone.js
// module id = 2331
// module chunks = 0